import localeData from 'dayjs/plugin/localeData';
import dayjs from 'dayjs';
import './index.scss';
import { Provider } from 'react-redux';
import store from './store';
import AntdConfigProvider from './AntdConfigProvider';
import Routes from './routes';
import './config/quill-blots';

dayjs.extend(localeData);

export default function App(): JSX.Element {
  document.title = `${process.env.REACT_APP_TITLE}: Sign in`;

  return (
    <Provider store={store}>
      <AntdConfigProvider>
        <Routes />
      </AntdConfigProvider>
    </Provider>
  );
}
